/**
  *  @fileOverview: 首页-通知模块
  *  @creator: CaoYanqi
  *  @Date: 2019/6/12
  *  @Last Modified by: 
  *  @Last Modified time:
  */
import * as React from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import {Empty, Spin} from 'antd'
import './productCard.less'
import QueueAnim from "rc-queue-anim";
import zhongyao from '../img/bg_zhongyao.png';
import hshangxian from '../img/bg_shagnxian.png';
import shangjia from '../img/bg_shangjia.png';
import xiajia from '../img/bg_xiajia.png';
import tingshou from '../img/bg_tingshou.png';
import {axios_} from "../../../tools/axios_";
import { Utils } from '../../../tools/utils'

class NotifyCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spinLoading:false,
      noticeList:[],
      messageTypeList:[
        {value:'1000',text:'产品上线通知'},
        {value:'1001',text:'产品下线通知'},
        {value:'1002',text:'产品恢复上线通知'},
        {value:'1003',text:'重要通知'},
        {value:'1004',text:'产品停售通知'}
      ]
    }
  }

  componentDidMount() {
    this.getNoticeList();
  }
  /**
   *获取通知列表
   */
  getNoticeList=()=>{
    this.setState({spinLoading:true});
    axios_({
      url:`noticeListApi`,
      method:'get',
      headers:{'Authorization':this.props.token},
      params: {limit: 5, page: 1}
    }).then(res=>{
      this.setState({spinLoading:false});
      if(res.data && res.data.status===200){
        this.setState({
          noticeList:res.data.data.list
        })
      }
    }).catch(e=>{
      this.setState({spinLoading:false});
    })
  };

  toNoticeList = () => {
    this.props.history.push('/system/noticeList/0')
  };
  getTypeText=(item)=>{
    const maxLength = Utils.isHLB() ? 80 : 42;
    // 有通知类型：【类型】+ 标题
    // 没有通知类型：标题 + 内容 (老旧数据)
    const result = item.messageType?
      `【${item.messageTypeName}】${item.messageTitle}`:
      `${ item.messageTitle}  ${item.messageContent}`
    return result.length > maxLength ? (result.substr(0, maxLength) + '...') : result
  };

  render() {
    const {noticeList = [], spinLoading} = this.state;
    return (
      <div>
        <Spin spinning={spinLoading} delay={100}>

          <div className="notify_card_wrap">
            <div className="header">
              <div className="title title_notify">通知
              </div>
            </div>
            <div className="card_box">
              <div className="card_box_content">
                <QueueAnim type='bottom' duration={100} >
                  {
                    noticeList[0] &&
                    <div className="item_first_wrap" key="item_first" onClick={()=>{
                      Utils.customTrack('MerchantHomeClick', {
                        element_content: '通知'
                      });
                      Utils.customTrack('MerchantHomeInformClick', {
                            inform_id:noticeList[0].messageId,
                            inform_name:noticeList[0].messageTitle
                    });
                      this.toNoticeList()
                    }}>
                      <div className="adver">
                        <img src='//image.zhongbaounion.com/icon/icon_important_1003.svg' alt=""/>
                      </div>
                      <div className="title_box">
                        <div className="title"><span>{noticeList[0].messageTitle}</span></div>
                        <span className="desc">{noticeList[0].messageContent}</span>
                      </div>
                    </div>
                  }

                  {
                    noticeList.length > 1 && noticeList.slice(1).map((item, index) => {
                      return (
                        <div className="item_wrap" key={index} onClick={()=>{
                          Utils.customTrack('MerchantHomeClick', {
                            element_content: '通知'
                          });
                          Utils.customTrack('MerchantHomeInformClick', {
                                inform_id:item.messageId,
                                inform_name:item.messageTitle
                          });
                          this.toNoticeList()
                        }}>
                      <p className="title">
                        {
                          this.getTypeText(item)
                        }
                      </p>
                          <span className="date_time">{item.noticeSendtime && item.noticeSendtime.split(' ')[0]}</span>
                        </div>
                      )
                    })
                  }
                </QueueAnim>
                {
                  !spinLoading && noticeList.length===0 &&
                  <div className="empty-box" key={'empty'}>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                  </div>
                }
              </div>
              <Link to={'/system/noticeList/0'} className="expand_btn" key="btn">查看全部</Link>
            </div>
          </div>
        </Spin>
      </div>

    )
  }
}

function mapState(state) {
  return {
    token: state.token
  }
}

export default connect(mapState)(NotifyCard)
